// extracted by mini-css-extract-plugin
export default {"container":"info-box_container__WCaI2","title":"info-box_title__O1wH1"};